export default async function getCsrfToken() {
    const response = await fetch('https://api.komorotel.com/api/auth/csrftoken', {
        method: 'GET',
        credentials: 'include' // Important pour inclure les cookies
    });
    const data = await response.json();
    return data.csrfToken; // Retourne le token
}
